let megamenuLazyload = false;
const megamenuImages = document.getElementsByClassName('megamenu--images');

document.addEventListener('mouseover', function(eventOn){
    megamenuLazyloading(eventOn);
});

document.addEventListener('keydown', function(eventDown){
    const dropdownLink = eventDown.target.getAttribute("megamenu-link");

    if(dropdownLink){
        megamenuLazyloading(eventDown);

        if (eventDown.key == "Enter" || eventDown.key == " " || eventDown.code == "Space") {
            eventDown.preventDefault();
            clearMegamenu();

            eventDown.target.nextElementSibling.classList.remove("non-active-megamenu");
            eventDown.target.nextElementSibling.classList.add("active-megamenu");
            eventDown.target.nextElementSibling.focus();
        }
    }

    if (eventDown.key == "Escape"){
        if(!eventDown.target.closest(".header__submenu.list-menu")){
            return 0;
        }
        else{
            eventDown.target.closest(".header__submenu.list-menu").previousElementSibling.focus();
            clearMegamenu();
        }
    }
});

document.addEventListener('keyup', function(eventUp){
    const dropdownLinkDescedant = eventUp.target.getAttribute("megamenu-link-descedant");

    if(sessionStorage.getItem('dropdownLinkValue') == "1"){
        if(document.activeElement.classList.contains('header__menu-item-with-dropdown')){
            sessionStorage.setItem('dropdownLinkValue', "");
            clearMegamenu();
        }
    }

    if(document.activeElement.classList.contains('header__menu-item-with-dropdown') || document.activeElement.classList.contains('header__menu-item-no-dropdown')){
        clearMegamenu();
    }

    if(dropdownLinkDescedant){
        sessionStorage.setItem('dropdownLinkValue', dropdownLinkDescedant);
    }
});

function clearMegamenu(){
    const menuDropdowns = document.querySelectorAll('.megamenu--dropdown');

    for (const menuDropdown of menuDropdowns){
        menuDropdown.classList.remove("active-megamenu");
        menuDropdown.classList.add("non-active-megamenu");
    }
}

function megamenuLazyloading(eventOn){
    if(megamenuLazyload === false){
        if (eventOn.target.getAttribute("megamenu-link")){
            for (const megamenuImage of megamenuImages){
                megamenuImage.src = megamenuImage.getAttribute("data-src");
            }
            
            megamenuLazyload = true; 
        }
    }
}